import {useRegistrationStyles} from "./registrationStyles";
import {Box, Grid} from "@material-ui/core";
import React from "react";


export const RegistrationSuccessful=()=>{
    let classes = useRegistrationStyles();
    
    return (
        <Box style={{marginTop:"80px"}}>
            <Box className={classes.titleBig}>
                MedPoint registration
            </Box>
            <Box className={classes.sectionTitle}>
                Thank you for registering for MedPoint
            </Box>
            <Grid container direction={"column"} spacing={2}>
                <Grid item>
                    We will contact you via email when your access to the MedPoint is ready.
                </Grid>
                <Grid item>
                    Your registration will be reviewed and processed by one of our consultants.
                </Grid>
            </Grid>
        </Box>
    );
};